"use strict";
// @ts-ignore
try {
    self['workbox:background-sync:6.2.4'] && _();
}
catch (e) { }
